import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CashBoxClosedPage } from './cash-box-closed.page';
import { CartModule } from '../cart/cart.module';
import { CashBoxRoutingModule } from './cash-box-routing.module';
import { CashBoxOpenModalComponent } from './cash-box-open-modal.component';
import { CashBoxCloseModalComponent } from './cash-box-close-modal.component';
import { CashRegisterActionsComponent } from './cash-register-actions.component';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
    CartModule,
    CashBoxRoutingModule,
    QRCodeComponent,
  ],
  declarations: [
    CashBoxClosedPage,
    CashBoxOpenModalComponent,
    CashBoxCloseModalComponent,
    CashRegisterActionsComponent
  ],
  providers: [
  ],
  exports: [
    CashBoxClosedPage,
    CashRegisterActionsComponent
  ]
})
export class CashBoxModule {}
